/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workflow_Event_NameInputs */

const cs_workflow_event_name = /** @type {(inputs: Workflow_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Událost`)
};

const en_workflow_event_name = /** @type {(inputs: Workflow_Event_NameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event`)
};

/**
* | output |
* | --- |
* | "Event" |
*
* @param {Workflow_Event_NameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const workflow_event_name = /** @type {((inputs?: Workflow_Event_NameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workflow_Event_NameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_workflow_event_name(inputs)
	return cs_workflow_event_name(inputs)
});